//   Header nav and mega menu start
$(document).ready(function () {
  let activeMegaMenu = ''

  function openMegaMenuProcess() {
    const menuName = $(this).attr('data-mega-menu')
    if (activeMegaMenu === '') {
      activeMegaMenu = menuName
      showMegaMenu(menuName)
    } else {
      noShowMegaMenu(activeMegaMenu)
      showMegaMenu(menuName)
      activeMegaMenu = menuName
    }
  }

  function showMegaMenu(name) {
    $(`.mega-menu[data-mega-menu='${name}']`).addClass('show')
  }

  function showMegaSmallMenu() {
    $(this).find('ul').toggleClass('show')
    $(this).find('.mega-menu-one__menu-list-item-icon.plus').toggleClass('show')
    $(this).find('.mega-menu-one__menu-list-item-icon.minus').toggleClass('show')
  }

  function noShowMegaMenu(name) {
    $(`.mega-menu[data-mega-menu='${name}']`).removeClass('show')
  }

  function closeMegaMenu() {
    $(`.mega-menu[data-mega-menu='${activeMegaMenu}']`).removeClass('show')
    activeMegaMenu = ''
  }

  $('.mega-menu-one__menu-list-item').on('click', showMegaSmallMenu)

  $('.mega-menu__container').on('mouseleave', closeMegaMenu)

  $('.header__nav-list-item').on('mouseenter', openMegaMenuProcess)

})
//   Header nav and mega menu end

// ----------------------------------------------------------------------------------------------------------------------------------------------------
// ----------------------------------------------------------------------------------------------------------------------------------------------------

//   Mobile menu start
$(document).ready(function () {
  let activeMobileMenuLink = ''

  function openMobileMenu() {
    $('.mobile-menu').addClass('show')
    $(this).removeClass('show')
    $('.mobile-menu__icon-close').addClass('show')
    $('body').addClass('hidden-overflow')
  }

  function closeMobileMenu() {
    $('.mobile-menu').removeClass('show')
    $('.header__icons-item-button-open').addClass('show')
    $('.mobile-menu__icon-close').removeClass('show')
    $('body').removeClass('hidden-overflow')
  }

  function mainDropdownProcess() {
    let parentElement = $(this).parent()
    if (activeMobileMenuLink !== '' && $(this).attr('data-link-name') !== activeMobileMenuLink) {
      $(`ul[data-link-name='${activeMobileMenuLink}']`).removeClass('show')
      activeMobileMenuLink = $(this).attr('data-link-name')
    } else {
      activeMobileMenuLink = $(this).attr('data-link-name')
    }
    parentElement.children('ul').toggleClass('show')
  }

  $('.header__icons-item-button-open').on('click', openMobileMenu)
  $('.mobile-menu__icon-close').on('click', closeMobileMenu)
  $('.mobile-menu__list-item-button.main').on('click', mainDropdownProcess)
  $('.mobile-menu__list-item--title').on('click', mainDropdownProcess)
})

//   Mobile menu end

// ----------------------------------------------------------------------------------------------------------------------------------------------------
// ----------------------------------------------------------------------------------------------------------------------------------------------------

//   Footer start
$(document).ready(function () {
  if ($('.footer-menu-list__item-list').length > 0) {
    $('.footer-menu-list__item-link-box').on('click', function () {
      $(this).toggleClass('active');
      if ($(this).next().hasClass("active")) {
        $(this).next().slideUp(200, function () {
          $(this).toggleClass('active')
        });
      } else {
        $(this).next().slideDown(200, function () {
          $(this).toggleClass('active')
        });
      }
    })
  }
})
//   Footer end